import React, { useState } from 'react';
import './CustomDatePicker.css';

const CustomDatePicker = ({ label, name, value, onChange, readOnly, disabled, required }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [viewDate, setViewDate] = useState(value ? new Date(value) : new Date());

  const handleDateSelect = (dateStr) => {
    onChange({ target: { name, value: dateStr } });
    setShowCalendar(false);
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const changeMonth = (delta) => {
    setViewDate(new Date(viewDate.getFullYear(), viewDate.getMonth() + delta, 1));
  };

  const renderCalendar = () => {
    const year = viewDate.getFullYear();
    const month = viewDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const today = new Date().toISOString().split('T')[0];
    const cells = [];

    for (let i = 0; i < firstDay; i++) {
      cells.push(<div key={`empty-${i}`} />);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const isToday = dateStr === today;
      const isSelected = value === dateStr;

      cells.push(
        <div
          key={day}
          className={`calendar-day ${isSelected ? 'selected' : ''} ${isToday ? 'today' : ''}`}
          onClick={() => handleDateSelect(dateStr)}
        >
          {day}
        </div>
      );
    }

    return cells;
  };

  return (
    <div className="g-input-datepicker">
      <input
        type="text"
        name={name}
        value={formatDisplayDate(value)}
        readOnly
        disabled={disabled || readOnly}
        className="form-control"
        onClick={() => !disabled && !readOnly && setShowCalendar(!showCalendar)}
        style={{ cursor: disabled || readOnly ? 'default' : 'pointer' }}
      />
      <label className={value ? 'active' : ''}>
        {label} {required && <span className="text-danger">*</span>}
      </label>
      {showCalendar && (
        <>
          <div className="calendar-overlay" onClick={() => setShowCalendar(false)} />
          <div className="calendar-popup">
            <div className="calendar-header">
              <button type="button" onClick={() => changeMonth(-1)}>‹</button>
              <span>{viewDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</span>
              <button type="button" onClick={() => changeMonth(1)}>›</button>
            </div>
            <div className="calendar-grid">
              {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                <div key={day} className="calendar-weekday">{day}</div>
              ))}
              {renderCalendar()}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomDatePicker;
